import React, { useState } from 'react'
import {
  Row, Col, Input, Modal, Tag,
} from 'antd'

import __ from '../../languages/parser'
import { useIsSmallDevice } from '../../hookreducer/hooks'

const SIZE = 'default'

const CalculatorModal = ({
  show,
  handleClose,
}) => {
  const isSmall = useIsSmallDevice()


  const baseWidth = {
    w80: 0,
    w60: 0,
    w40: 0,
  }

  const baseHeight = {
    option: null,
    h77: 0,
    h44: 0,
    heighto1: null,
    heighto2: null,
  }

  const [longueur, setLongueur] = useState('')
  const [hauteur, setHauteur] = useState('')
  const [getWidth, setWidth] = useState(baseWidth)
  const [getHeight, setHeight] = useState(baseHeight)

  const calculNb = (height, width) => {
    // Nb of 44 if 77 optimisation
    const nbMax77 = Math.floor(height / 77)
    const nbMax44Option1 = Math.floor((height - (nbMax77 * 77)) / 44)
    const heightOption1 = nbMax77 * 77 + nbMax44Option1 * 44

    // Nb of 44 if 44 optimisation
    const nb77For44Optimisation = nbMax77 > 0 ? nbMax77 - 1 : 0
    const nbMax44Option2 = Math.floor((height - (nb77For44Optimisation * 77)) / 44)
    const heightOption2 = nb77For44Optimisation * 77 + nbMax44Option2 * 44

    const heightOption = heightOption1 >= heightOption2 ? 'h1' : 'h2'

    // Nb of width 80 if 80 optimisation
    const nbMax80 = Math.floor(width / 80)
    const nbMax60Option1 = Math.floor((width - (nbMax80 * 80)) / 60)
    const nbMax40Option1 = Math.floor((width - (nbMax80 * 80) - (nbMax60Option1 * 60)) / 40)
    const widthOption1 = nbMax80 * 80 + nbMax60Option1 * 60 + nbMax40Option1 * 40

    // Nb of width 80 if 60 and 40 optimisation
    const nbMax80Option2 = nbMax80 > 0 ? nbMax80 - 1 : 0
    const nbMax60Option2 = Math.floor((width - (nbMax80Option2 * 80)) / 60)
    const nbMax40Option2 = Math.floor((width - (nbMax80Option2 * 80) - (nbMax60Option2 * 60)) / 40)
    const widthOption2 = nbMax80Option2 * 80 + nbMax60Option2 * 60 + nbMax40Option2 * 40

    const widthOption = widthOption1 === widthOption2
      ? nbMax60Option2 > nbMax60Option1 ? 'w2' : 'w1'
      : widthOption1 > widthOption2 ? 'w1' : 'w2'

    if (widthOption === 'w1') {
      setWidth({
        w80: nbMax80,
        w60: nbMax60Option1,
        w40: nbMax40Option1,
      })
    } else if (widthOption === 'w2') {
      setWidth({
        w80: nbMax80Option2,
        w60: nbMax60Option2,
        w40: nbMax40Option2,
      })
    }

    if (heightOption === 'h1') {
      setHeight({
        option: 'h1',
        h77: nbMax77,
        h44: nbMax44Option1,
        heighto1: heightOption1,
      })
    } else if (heightOption === 'h2') {
      setHeight({
        option: 'h2',
        h77: nb77For44Optimisation,
        h44: nbMax44Option2,
        h77o2: nbMax77,
        h44o2: nbMax44Option1,
        heighto1: heightOption1,
        heighto2: heightOption2,


      })
    }
  }

  const setAndCalcul = (dim, value) => {
    const currentLongueur = dim === 'length' ? value : longueur
    const currentHauteur = dim === 'height' ? value : hauteur

    setLongueur(currentLongueur)
    setHauteur(currentHauteur)

    if (currentLongueur >= 40 && currentHauteur >= 77) {
      calculNb(currentHauteur, currentLongueur)
    } else {
      setWidth(baseWidth)
      setHeight(baseHeight)
    }
  }

  return (
    <Modal
      title={__('Number of Wall bases')}
      visible={show}
      onCancel={handleClose}
      footer={null}
      zIndex={10000}
      width={isSmall ? '80%' : '50%'}

    >
      <Row>
        <Col span="10">
          {`${__('Width')} (cm)`}
        </Col>
        <Col offset={2} span="10">
          {`${__('Height')} (cm)`}
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <Input placeholder={`${__('Width')} (cm)`} value={longueur} size={SIZE} onChange={(e) => setAndCalcul('length', parseInt(e.target.value, 10) || null)} />
        </Col>
        <Col offset={2} span="10">
          <Input placeholder={`${__('Height')} (cm)`} value={hauteur} size={SIZE} onChange={(e) => setAndCalcul('height', parseInt(e.target.value, 10) || null)} />
        </Col>
      </Row>
      <Row style={{ marginTop: '30px' }}>
        {__('You can combine in width:')}
      </Row>
      <Row>
        <Col offset="1" span="6">
          <span style={{ opacity: getWidth.w80 ? '100%' : '15%' }}>
            <Tag>{getWidth.w80}</Tag>
            {' '}
            base(s) 80cm
          </span>
        </Col>
        <Col offset="1" span="6">
          <span style={{ opacity: getWidth.w60 ? '100%' : '15%' }}>
            <Tag>{getWidth.w60}</Tag>
            {' '}
            base(s) 60cm
          </span>

        </Col>
        <Col offset="1" span="6">
          <span style={{ opacity: getWidth.w40 ? '100%' : '15%' }}>
            <Tag>{getWidth.w40}</Tag>
            {' '}
            base(s) 40cm
          </span>
        </Col>
      </Row>

      <Row style={{ marginTop: '30px' }}>
        {__('You can combine in height:')}
      </Row>
      <Row>
        <Col offset="3" span="5">
          <span style={{ opacity: getHeight.h77 ? '100%' : '15%' }}>
            <Tag>{getHeight.h77}</Tag>
            {' '}
            base(s) 77cm
          </span>
        </Col>
        <Col offset="1" span="5">
          <span style={{ opacity: getHeight.h44 ? '100%' : '15%' }}>
            <Tag>{getHeight.h44}</Tag>
            {' '}
            base(s) 44cm
          </span>
        </Col>
        <Col offset="1" span="3">
          <span style={{ opacity: getHeight.heighto1 ? '100%' : '15%' }}>
            (
            {getHeight.heighto2}
            {' '}
            cm)

          </span>
        </Col>
      </Row>

      {getHeight.option === 'h2'
        ? (
          <>
            <Row style={{ margin: '10px', width: '100%', textAlign: 'center' }}>{__('or')}</Row>
            <Row>
              <Col offset="3" span="5">
                <span style={{ opacity: getHeight.h77o2 ? '100%' : '15%' }}>
                  <Tag>{getHeight.h77o2}</Tag>
                  {' '}
                  base(s) 77cm
                </span>
              </Col>
              <Col offset="1" span="5">
                <span style={{ opacity: getHeight.h44o2 ? '100%' : '15%' }}>
                  <Tag>{getHeight.h44o2}</Tag>
                  {' '}
                  base(s) 44cm
                </span>
              </Col>
              <Col offset="1" span="3">
                <span style={{ opacity: getHeight.heighto2 ? '100%' : '15%' }}>
                  (
                  {getHeight.heighto1}
                  {' '}
                  cm)
                </span>
              </Col>
            </Row>
          </>
        )
        : null}
    </Modal>
  )
}

export default CalculatorModal
